import type {
  ExtractionAiFieldCell,
  ExtractionAiFieldCells,
} from '~/features/dynamic-data-extraction/types/ExtractionAiFieldCell';

import { buildAiFieldCellKey } from './aiFieldCellKey';

export const getAiFieldCell = (
  aiFieldCells: ExtractionAiFieldCells | undefined,
  documentHandlerId: string,
  fieldId: string,
): ExtractionAiFieldCell | undefined =>
  aiFieldCells?.[buildAiFieldCellKey(documentHandlerId, fieldId)];
